<template>
    <span v-if="str">{{str}}</span>
    <i v-else>Empty</i>
</template>

<script>
export default {
    props: ['str']
}
</script>

<style>
i {
  font-size: 14px;
  font-weight:lighter;
  color: rgb(161 161 170);
}
</style>